export const SECTIONS = [
  {
    title: "Array",
    fields: [
      { key: "module", label: "Module", labelClass: "m_label" },
      { key: "quantity", label: "Quantity" },
    ],
  },
  {
    title: "Array Parameters (as specified)",
    fields: [
      { key: "Voc(STC)", label: "Voc(STC)" },
      { key: "Isc(STC)", label: "Isc(STC)" },
    ],
  },
  {
    title: "String over-current protective device",
    fields: [
      { key: "protective_type", label: "Type" },
      { key: "Rating", label: "Rating (A)" },
      { key: "DC Rating", label: "DC Rating (V)" },
      { key: "Capacity", label: "Capacity (kA)" },
    ],
  },
  {
    title: "String Wiring",
    fields: [
      { key: "wiring_type", label: "Type" },
      { key: "wiring_phase_csa", label: "Phase CSA (mm2)" },
      { key: "wiring_earth_csa", label: "Earth CSA (mm2)" },
    ],
  },
  {
    title: "String Test",
    fields: [
      { key: "test_voc", label: "Voc(STC)" },
      { key: "test_isc", label: "Isc(STC)" },
      { key: "test_irradiance", label: "Irradiance" },
    ],
  },
  {
    title: "Polarity Check",
    fields: [{ key: "polarity_check", label: "", fullWidth: true }],
  },
  {
    title: "Array Insulation Resistance",
    fields: [
      { key: "test_voltage", label: "Test Voltage (V)" },
      { key: "pos_earth", label: "Pos - Earth (MΩ)" },
      { key: "neg_earth", label: "Neg - Earth (MΩ)" },
    ],
  },
  {
    title: "Earth Continuity (where fitted)",
    fields: [{ key: "earth_continuity", label: "", fullWidth: true }],
  },
  {
    title: "Array Isolator",
    fields: [
      { key: "Rating (A)", label: "Rating (A)" },
      { key: "Rating (V)", label: "Rating (V)" },
      { key: "isolator_location", label: "Location" },
      { key: "isolator_functional_check", label: "Functional Check" },
    ],
  },
];
